import React, { useState } from 'react';
import { useAnalyticsContext } from '@/context/analyticsContext';

type YouTubeVideoProps = {
  videoId: string;
  title?: string;
};

const YouTubeVideo: React.FC<YouTubeVideoProps> = ({
  videoId,
  title = 'Video',
}) => {
  const { customTrack } = useAnalyticsContext();

  const [hasInteracted, setHasInteracted] = useState(false);

  if (!videoId) return null;

  const baseEmbedUrl = `https://www.youtube.com/embed/${videoId}`;
  const iframeSrc = hasInteracted ? `${baseEmbedUrl}?autoplay=1` : baseEmbedUrl;

  const handlePlayClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    customTrack({
      event: e,
      identifier: 'culinary collective',
      element: 'Play Video',
    });

    setHasInteracted(true);
  };

  return (
    <div className="tw-relative tw-aspect-videoEmbed tw-w-full tw-overflow-hidden tw-rounded-2xl tw-bg-gray-300">
      <iframe
        className="tw-block tw-h-full tw-w-full tw-rounded-2xl"
        src={iframeSrc}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="origin"
        allowFullScreen
        loading="lazy"
      />

      {!hasInteracted && (
        <button
          type="button"
          onClick={handlePlayClick}
          aria-label="Culinary Collective Video"
          className="tw-absolute tw-inset-0 tw-z-10 tw-border-0 tw-bg-transparent tw-p-0"
        />
      )}
    </div>
  );
};

export default YouTubeVideo;
